import { Spacer } from '#app/shared/ui/data-display/Spacer.js'
import { Icon } from '#app/shared/ui/icons/Icon.js'

type Props = {
  setOpen: (val: boolean) => void
}

export default function CheckModalContent({ setOpen }: Props) {
  return (
    <div
      className={`
        fixed left-1/2 top-1/2 w-[328px] -translate-x-[50%] -translate-y-[50%]
        rounded-base border border-neutral-75 bg-white p-0

        sm:w-[480px]

        xl:rounded-t-none
      `}
    >
      <div
        className={`
          relative pt-[69px]

          sm:pt-12
        `}
      >
        <Icon
          name="basic/x"
          size="24px"
          className={`absolute right-4 top-4 text-neutral-300`}
          onClick={() => setOpen(false)}
        />
        <div className="flex flex-col items-center justify-center px-11">
          <img
            src="/img/Group 240.png"
            className="h-[94px] w-[94px]"
            alt="car-group"
          />
          <Spacer size="12px" />
          <p className="text-h5-medium text-neutral-700">Solicitud recibida</p>
          <Spacer size="20px" />
          <p className="text-center text-h3 text-neutral-900">
            ¡Enviaremos la certificación del vehículo muy pronto!
          </p>
        </div>
        <Spacer size="40px" />

        <div
          className={`
            flex w-full flex-col items-center justify-between gap-5 border-t
            border-neutral-75 px-11 py-7

            sm:flex-row sm:py-8
          `}
        >
          <div
            className={`
              flex flex-col items-center gap-2

              sm:items-start
            `}
          >
            <p className="text-nowrap text-h4 text-neutral-900">
              ¿Necesitas ayuda?
            </p>
            <p className="text-nowrap text-subtitle1-bold text-primary-600">
              Estamos aquí para ayudarte.
            </p>
          </div>

          <div className="flex items-center gap-2">
            <Icon
              name="basic/phone-call"
              size="24px"
              className="text-primary-500"
            />
            <p className="text-nowrap text-h4 text-neutral-900">919 015 000</p>
          </div>
        </div>
      </div>
    </div>
  )
}
